import { useTranslation } from '@eti/providers';
import { Button, Inline, vars } from '@etg/wings';
import { Icon } from '@eti/components';
import { css, etiColors } from '@eti/styles';
import type { Dispatch, SetStateAction } from 'react';

const buttonTagStyles = css`
  background-color: ${vars.colors.promotional.foreground};
  border: none;
  border-radius: 8px;
  color: ${etiColors.white};
  padding: 4px 8px;

  :hover {
    background-color: ${vars.colors.promotional.foreground};
    color: ${etiColors.white};
  }
`;

interface SelfTransferTagButtonProps {
  setIsSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
}

const SelfTransferTagButton = ({ setIsSelfTransferModalOpen }: SelfTransferTagButtonProps) => {
  const { t } = useTranslation();

  return (
    <Inline>
      <Button
        className={buttonTagStyles}
        data-testid="self-transfer-trip-tag-button"
        onClick={setIsSelfTransferModalOpen ? () => setIsSelfTransferModalOpen(true) : undefined}
      >
        <Icon color={etiColors.white} id="self-transfer" size="1.125rem" />
        <span>{t('Result.Page.SelfTransferDeals.Button.Text')}</span>
      </Button>
    </Inline>
  );
};

export default SelfTransferTagButton;
